import { render, staticRenderFns } from "./Scheduling.vue?vue&type=template&id=8c95f60e&scoped=true&lang=pug&"
import script from "./Scheduling.vue?vue&type=script&lang=js&"
export * from "./Scheduling.vue?vue&type=script&lang=js&"
import style0 from "./Scheduling.vue?vue&type=style&index=0&id=8c95f60e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c95f60e",
  null
  
)

/* custom blocks */
import block0 from "./Scheduling.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VRadio,VRadioGroup,VSelect})
